<template>
  <div role="tablist">
          <h1>{{ getContacts }}</h1>
    <b-card v-for="(item,index) in getGeneral" :key="index" no-body class="mb-1">

      <b-card-header header-tag="header" class="p-1" role="tab">

        <b-button  block v-b-toggle="'accordion-' + index"
        variant="info">{{ item.title }}</b-button>
      </b-card-header>
      <b-collapse
      :id="'accordion-' + index" visible accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
            {{item.text}}
</b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>
     <h1>{{ getRegionsTitle }}</h1>
        <b-card v-for="(item,index) in getRegions" :key="index+10" no-body class="mb-1">

      <b-card-header header-tag="header" class="p-1" role="tab">

        <b-button  block v-b-toggle="'accordion-' + index+10"
        variant="info">{{ item.title }}</b-button>
      </b-card-header>
      <b-collapse
      :id="'accordion-' + index+10" visible accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
            {{item.text}}
</b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
export default {
  computed: {
    currentLocale() {
      return this.$store.state.calc.currentLocale;
    },
    getGeneral() {
      const lang = this.currentLocale;
      return this.form[lang].general;
    },
    getRegions() {
      const lang = this.currentLocale;
      return this.form[lang].regions;
    },
    getContacts() {
      const lang = this.currentLocale;
      return this.form.titles[lang].general;
    },
    getRegionsTitle() {
      const lang = this.currentLocale;
      return this.form.titles[lang].regions;
    },
  },
  data() {
    return {
      form: {
        titles: {
          ru: { regions: 'Филиалы', general: 'Контакты' },
          kz: { regions: 'Филиалдар', general: 'Байланыс' },
        },
        ru:
        {
          general: [{
            title: 'Головное подразделение', text: `Республика Казахстан, 050016,
г. Алматы пр. Суюнбая, 89 «А»

Тел/факс: 8 (727) 383-17-15

Email: info@fishrpc.kz`,
          }, {
            title: 'Испытательный центр', text: `Таирова Бахтинур Тельменовна
И.о.руководителя испытательного центра
8 (727) 383-15-06
bahti_1980@mail.ru`,
          }, {
            title: 'Лаборатории', text: `Марленов Эльдар Берікұлы
Заведующий лабораторией ихтиологии
8(727) 383-17-18
marlenov.eldar@gmail.com
Мажибаева Жанара Омирбековна
Заведующий лабораторией гидробиологии и гидроаналитики
8 (727) 383-15-03
mazhibayeva@fishrpc.kz
Койшыбаева Сая Кашкинбаевна
Заведующий лабораторией аквакультуры
8 (727) 390-95-65
koishybayeva@fishrpc.kz
Шалгимбаева Гульмира Мухаметкалиевна
Заведующий лабораторией генетики гидробионтов
8 (727) 220-98-13
shalgimbayeva@fishrpc.kz`,
          },
          {
            title: 'Отделы', text: `Улдаханова Айна Камаловна
Начальник финансово-экономического отдела, главный бухгалтер
8 (727) 390-95-74
uldakhanova@fishrpc.kz
Мухрамова Алёна Александровна
Начальник информационно-инновационного отдела
8 (727) 383-15-06
mukhramova@fishrpc.kz
Джумаканов Аскар Кадыралиевич
Начальник административно-хозяйственного отдела
8 (727) 390-95-81
jumakanov@fishrpc.kz
Оспанова Нургуль Аджахуновна
Юрист
8 (727) 383-15-02
lawyerniirh@mail.ru
Калгожаева Айгуль Мухамбаевна
Менеджер по кадрам
8 (727) 383-17-16
aigul.kalgozhaeva@mail.ru`,
          }],
          regions: [{
            title: 'Атырауский', text: `Кадимов Ерболат Латифович
Директор Атырауского филиала
8 (712-2) 36-69-30
Байдербесова Гульнар
Старший бухгалтер
8 (712-2) 36-69-58
Камиева Тыныштык Наурызгалиевна
Зав. комплексной рыбохозяйственной лабораторией
8 (712-2) 36-69-30

Email: atyrau.fish_npc@mail.ru`,
          }, {
            title: 'Аральский', text: `Баракбаев Тынысбек Темирханович
Директор Аральского филиала
8 (724-33) 2-18-40
Куттымуратова Алмагуль Амитовна
Старшый бухгалтер
8 (724-33) 2-38-06

Email: aral@fishrpc.kz`,
          }, {
            title: 'Алтайский', text: `Аубакиров Бауржан Саветович
Директор Алтайского филиала
8(7232)21-13-41
Жамантикова Гульфайроз МамашевнаК
Главный бухгалтер
8(7232)51-07-45
Касымханов Айбек Махамбетович
Зав. комплексной рыбохозяйственной лабораторией
8(7232)52-71-10
Кабдолов Жаркын Русланович
Зав. опорным пунктом г. Павлодар
-

Email: altay@fishrpc.kz`,
          }, {
            title: 'Балхаский', text: `Куматаев Еркинбек Ерикович
директор Балхашского филиала
8 (710-36) 4-14-748 (710-36) 4-85-25
Жаумбаева Гульсим Абиловна
Старший бухгалтер
8 (710-36) 4-14-74
Цой Вячеслав Николаевич
зав. комплексной рыбохозяйственной лабораторией
8(71036)4-14-74

Email: balkhash@fishrpc.kz`,
          }, {
            title: 'Западно-Казахстанский', text: `Туменов Артур Насибуллаулы
Директор Западно-Казахстанского филиала
8 (711-2) 28-11-268 (710-36) 4-85-25
Хулжанова Асель Каировна
Старший бухгалтер
8 (711-2) 24-05-56
Ким Аркадий Игнатьевич
Зав. комплексной рыбохозяйственной лабораторией
8 (711-2) 28-11-26

Email: uralsk@fishrpc.kz`,
          }, {
            title: 'Северный', text: `Шуткараев Азис Васильевич
Директор Северного филиала
8 (7172) 43-67-90
Бексултанова Гульнара Кайнуллиновна
Старший бухгалтер
8 (7172) 57-63-71
Фефелов Виктор Владимироваич
Заведующий лабораторией
8 705-650-15-65
Крайнюк Владимир Николаевич
Заведующий опорным пунктом г. Караганда
8-707-671-37-71
Попов Владимир Анатольевич
Заведующий опорным пунктом г. Костанай
8-702-857-61-505

Email: north@fishrpc.kz`,
          }],
        },
        kz: {
          general: [{
            title: 'Бас Филиал', text: `

Қазақстан, Алматы қаласы, Суйінбай даңғылы 89 «А» үйі

Тел/факс: 8 (727) 383-17-15

Email: info@fishrpc.kz

Басшылық
Исбеков Қуаныш Байболатұлы
Бас директор
+7 (727) 383-15-05
isbekov@fishrpc.kz
Асылбекова Сәуле Жәңгірқызы
Бас директордың орынбасары
+7 (727) 383-17-14
assylbekova@fishrpc.kz
Жаркенов Дамир Қайыркелдіұлы
Бас ғылыми хатшы
+7 (727) 390-95-75
zharkenov@fishrpc.kz

`,
          },
          {
            title: 'Сынақ орталығы', text: `Таирова Бақтынұр Телманқызы
м.а.сынақ орталығының басшысы
8 (727) 383-15-06
bahti_1980@mail.ru
`,
          }, {
            title: 'Зертханалар', text: `
Марленов Эльдар Берікұлы
Ихтилогия зертханасының меңгерушісі
8(727) 383-17-18
marlenov.eldar@gmail.com
Мәжібаева Жанар Өмірбекқызы
Гидробиология және гидроаналитика зертханасының меңгерушісі
8 (727) 383-15-03
mazhibayeva@fishrpc.kz
Койшыбаева Сая Қашқынбайқызы
Аквакультура зертханасының меңгерушісі
8 (727) 390-95-65
koishybayeva@fishrpc.kz
Шалғымбаева Гүлмира Мұхаметқалиқызы
Гидробионттар генекасы зертханасының мегерушісі
8 (727) 220-98-13
shalgimbayeva@fishrpc.kz
`,
          }, {
            title: 'Бөлімдер', text: `
Улдаханова Айна Камалқызы
Қаржылық-экономикалық бөлімнің басшысы, бас бухгалтер
8 (727) 390-95-74
uldakhanova@fishrpc.kz
Мухрамова Алена Александровна
Ақпараттық-инновациялық бөлімнің басшысы
8 (727) 383-15-06
mukhramova@fishrpc.kz
Джумаканов Аскар Қадыралиұлы
Әкімшілік-шаруашылық бөлімінің басшысы
8 (727) 390-95-81
jumakanov@fishrpc.kz
Оспанова Нұргүл Аджахунқызы
Юрист
8 (727) 383-15-02
lawyerniirh@mail.ru
Калгожаева Айгүл Мукамбайқызы
Кадрлар бойынша менеджер
8 (727) 383-17-16
kalgozhaeva@fishrpc.kz
`,
          }],
          regions: [{
            title: 'Атырау', text: `
Кадимов Ерболат Латифұлы
Атырау филиалының директоры
8 (712-2) 36-69-30
Байдербесова Гүлнар
Аға бухгалтер
8 (712-2) 36-69-58
Камиева Тыныштык Наурызгалиқызы
Зертхана меңгерушісі
8 (712-2) 36-69-30

E-mail:atyrau.fish_npc@mail.ru
`,

          }, {
            title: 'Арал', text: `Баракбаев Тынысбек Темирханұлы
Арал филиалының директоры
8 (724-33) 2-18-40
Куттымуратова Алмагүл Амитқызы
Аға бухгалтер
8 (724-33) 2-38-06

E-mail: aral@fishrpc.kz
`,
          }, {
            title: 'Алтай', text: `
Аубакиров Бауыржан Саветұлы
Алтай филиалының директоры
8 (7232) 21-13-41
Жамантикова Гүлфайроз Мамашқызы
Аға бухгалтер
8 (7232) 51-07-45
Қасымханов Айбек Махамбетұлы
Зертхана меңгерушісінің қ.а.
8 (7232) 52-71-10
Қабдолов Жарқын Русланұлы
Павлодар қ, бекініс нүктесінің қолбасары
-

E-mail: altay@fishrpc.kz
`,
          }, {
            title: 'Балқаш', text: `
Куматаев Еркынбек Ерикович
Балхаш филиалының директоры
8 (710-36) 4-14-748 (710-36) 4-85-25
Жаумбаева Гульсим Абиловна
Аға бухгалтер
8 (710-36) 4-14-74
Құматаев Еркынбек Ерікұлы
Зертхана меңгерушісі
8 (710-36) 4-14-74

E-mail: balkhash@fishrpc.kz
`,
          }, {
            title: 'Батыс Қазақстан', text: `
Туменов Артур Насибуллаулы
Батыс Қазақстан филиалының диреторы
8 (711-2) 28-11-268 (710-36) 4-85-25
Хулжанова Асель Каирқызы
Аға бухгалтер
8 (711-2) 24-05-56
Ким Аркадий Игнатьевич
Зертхана меңгерушісі
8 (711-2) 28-11-26

E-mail: uralsk@fishrpc.kz`,
          }, {
            title: 'Солтүстік', text: `
Шуткараев Азис Васильевич
Солтүстік филиалының директоры
8 (7172) 43-67-90
Бексултанова Гүлнар Кайнуллинқызы
Аға бухгалтер
8 (7172) 57-63-71
Фефелов Виктор Владимироваич
Лаборатория меңгерушісі
8 705-650-15-65
Крайнюк Владимир Николаевич
Қарағанды қ.опорлы пунктінің меңгерушісі
8-707-671-37-71
Попов Владимир Анатольевич
Қарағанды қ.опорлы пунктінің меңгерушісі
8-702-857-61-505

E-mail: north@fishrpc.kz
`,
          }],
        },
      },


    };
  },
};
</script>

<style scoped>
.card-text {
  color: black;
}

.card{
        max-width: 1100px;
        margin:0 auto;
}
</style>
